/**
 * CompleteBookingPage: the only rule this page owns. Everything else is the
 * shipped FormRequestPage surface (FormRequestPage.module.css), reused as is.
 *
 * "Finish by {deadline}": the flow's shipped reserved-until pill, copied from
 * DetailsPage.module.css .reservedInfo (manual-booking-complete.html frames 3-4).
 */
.finishBy {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin-top: 2px;
  padding: 7px 11px;
  align-self: flex-start;
  background: rgba(var(--accent-rgb), 0.1);
  border-radius: 10px;
  font-size: 12.5px;
  color: var(--accent);
}

/* The computer website's column (web-account-pages D11, complete-booking.html "The step in a
   centered column"): the step inside the site's page, so none of the screen's fixed rails. */
.column {
  position: relative;
  max-width: 560px;
  margin: 30px auto 0;
  color: var(--text-primary);
  font-family: var(--font-body);
}

.columnHead {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 0 20px 14px;
  border-bottom: 1px solid var(--border-subtle);
}

/* Loading and the step that could not load: the screen's centered states, in a box of their own. */
.columnState {
  position: relative;
  min-height: 420px;
}
